import { RESET } from '../actionTypes';
import { proposalsActions } from '../reducer';

export default () => proposalsActions[RESET]();
